import React from "react";
import { Card, Table } from "react-bootstrap";
import "./SNPDistanceSampleDisplay.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import isEqual from "react-fast-compare";

export default class SampleSNPDistance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            samples: this.props.roomDetails.sample_areas.map((sample) => sample.sample_data)
        }

    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.roomName, this.props.roomName)) {
            this.setState({
                samples: this.props.roomDetails.sample_areas.map((sample) => sample.sample_data)
            });
        }
    }

    render() {
        var settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1530,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: true,
                        infinite: false,                        
                    }
                },
                {
                    breakpoint: 1160,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        infinite: false,
                    }
                },
                {
                    breakpoint: 730,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        infinite: false,
                    }
                }
            ]
        };
        return (
            <div className="carousel track-result-cord">
                <div className="d-flex justify-content-between bd-highlight mb-2">
                    <div className="bd-highlight room-name ">  {this.props.roomName ? this.props.roomName : null}</div>
                </div>
                {this.state.samples.length > 0 ?
                    <Slider {...settings}>
                        {this.state.samples.map((sample) => {
                            return (
                                sample.map((item) => {
                                    return (
                                        <Card className="snp-result-card">
                                            <Card.Body className="d-flex p-2 candidate-card">
                                                <div className="barcode-sample-box" style = {{backgroundColor:item.color}}>
                                                </div>
                                                <Table borderless>
                                                    <tbody>
                                                        {item.barcodeOne && item.locationone ?
                                                            <tr>
                                                                <td className="bodyCopy">EF Barcode  : </td>
                                                                <td className="bodyCopy">{item.barcodeOne}</td>
                                                                <td className="bodyCopy" >{item.barcodetwo}</td>
                                                            </tr>
                                                            : null
                                                        }
                                                        {item.barcodetwo && item.locationtwo ?
                                                            <tr>
                                                                <td className="bodyCopy">Location : </td>
                                                                <td className="bodyCopy">{item.locationone}</td>
                                                                <td className="bodyCopy" >{item.locationtwo}</td>
                                                            </tr>
                                                            : null
                                                        }
                                                        {item.snpDistance ?
                                                            <tr>
                                                                <td className="bodyCopy">SNP Distance: </td>
                                                                <td className="bodyCopy">{item.snpDistance}</td>
                                                            </tr>
                                                            : null
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Card.Body>
                                        </Card>
                                    )
                                })
                            )

                        })}
                    </Slider>
                    :
                    <div className="no-msg-text">No results available for this room.</div>}
            </div>
        );
    }
}
